const question2 = {
    'question': 'Czym jest interwencja kryzysowa?',
    'answer': 'Interwencja kryzysowa obejmuje osoby, które przeżywają kryzys psychiczny. Kryzys psychiczny to sytuacja, w której osoba nie jest w stanie poradzić sobie z trudnym doświadczeniem życiowym. Może to być spowodowane przez różne czynniki, takie jak: nagła utrata bliskiej osoby, przemoc w rodzinie, uzależnienia czy utrata pracy.'
}

export default question2;